import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { DontShowAgainCheckbox } from "./DontShowAgainCheckbox";
import styles from "./Controls.module.scss";

interface Props {
    currentStep: number;
    totalSteps: number;
    hasStepData: boolean;
    onPrevStep: () => void;
    onCancel: () => void;
}

export const Controls = ({ currentStep, totalSteps, hasStepData, onPrevStep, onCancel }: Props) => {
    const { t } = useTranslation();

    const isFirstPage = currentStep === 1;
    const isLastPage = currentStep === totalSteps;

    const onGoBack = () => {
        if (isFirstPage) {
            onCancel();
        } else {
            onPrevStep();
        }
    };

    const getNextButtonLabel = () => {
        if (isLastPage) return t("searchAssist.search");
        if (hasStepData) return t("searchAssist.step", { step: currentStep + 1 });
        return t("searchAssist.dontKnow");
    };

    return (
        <div className={classNames("modalSection", styles.controls)}>
            <button
                onClick={onGoBack}
                className={classNames("ancBtn", {
                    silver: isFirstPage,
                    iconArrowLeft: !isFirstPage,
                    icon: !isFirstPage,
                })}
                type="button"
            >
                {t(isFirstPage ? "searchAssist.cancel" : "searchAssist.back")}
            </button>
            {isLastPage && <DontShowAgainCheckbox />}
            <button
                className={classNames("ancBtn", {
                    "iconAfter iconArrowRightAfter": hasStepData && !isLastPage,
                })}
                type="submit"
            >
                {getNextButtonLabel()}
            </button>
        </div>
    );
};
